import configMixin from '../mixins/configMixin';
<template>
  <div class="banner">
    <div class="banner-inner" ref="banner" :class="backgroundClasses" :style="`${backgroundImgStyle}`"></div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import { debounce } from '@/common/utils';
import { debounceFirst } from '@/common/utils';

export default {
  name: 'Banner',
  mixins: [common, configMixin],
  props: {
    config: {
      type: Object,
    },
  },
  mounted() {
    let el = document.getElementById('router-view');
    if (el) {
      el.addEventListener('scroll', debounceFirst(this.onScroll, 20));
    }
  },
  destroyed() {
    let el = document.getElementById('router-view');
    if (el) {
      el.removeEventListener('scroll', this.onScroll);
    }
  },
  data() {
    return {
      translateY: 0,
    };
  },
  computed: {
    backgroundClasses() {
      return this.config.background ? this.config.background[this.darkMode ? 'dark' : 'light'] : '';
    },
    backgroundImgStyle() {
      let style = '';
      if (this.config.backgroundImg) {
        style += `background:url('${this.assetUrl(this.darkMode && this.config.backgroundImgDark?this.config.backgroundImgDark:this.config.backgroundImg)}')`;
      }

      style += `;background-size:${this.config.backgroundSize ? this.config.backgroundSize : 'cover'}`;
      style += `;background-position:${this.config.backgroundPosition ? this.config.backgroundPosition : 'right center'}`;
      style += `;height:${this.config.height ? this.config.height : '40vh'}`;
      if (this.$vuetify.breakpoint.xs) {
        style += `;height:${this.config.heightXs ? this.config.heightXs : '20vh'}`;
      }

      return style;
    },
  },

  methods: {
    onScroll() {
      let el = document.getElementById('router-view');
      if (this.$refs.banner && el) {
        let yTop = el.scrollTop;
        this.$refs.banner.style.transform = `translateY(${-yTop / 4}px)  scale(${1 + yTop / 256})`;
      }
    },
  },
};
</script>
<style scoped>
.banner {
  overflow: hidden;
}

.banner-inner {
  transition: transform 2000ms cubic-bezier(0.075, 0.82, 0.165, 1);
}
</style>
